import React from 'react';
import { cx } from '../cx';
import { pageWidthClass, type PageWidth } from './Page';
import { ScrollTopButton } from './ScrollTopButton';

// D-07 §21.4 — PageScroll (.page-scroll). <Page layout="fixed"> 내부의 스크롤 영역.
// 스크롤은 바깥 div 가 갖고, 폭·패딩은 안쪽 컬럼이 갖는다 — <Page layout="doc"> 과
// 콘텐츠 실폭이 같아지도록 맞춘 것(폭 안쪽에 패딩).
export interface PageScrollProps extends React.HTMLAttributes<HTMLDivElement> {
  /** 중앙 컬럼 최대폭. 기본 'full'(제한 없음) */
  width?: PageWidth;
  /** 페이지 패딩(32px). 기본 true */
  pad?: boolean;
}

// ref 는 바깥 .page-scroll(스크롤 소유자)에 붙는다 — 스크롤 위치 저장·복원,
// IntersectionObserver root 지정처럼 소비처가 스크롤 컨테이너를 직접 잡아야 하는 경우가 있다.
export const PageScroll = React.forwardRef<HTMLDivElement, PageScrollProps>(function PageScroll(
  { width = 'full', pad = true, className = '', children, ...props },
  ref,
) {
  const inner = cx(pad && 'page-pad', pageWidthClass(width));
  return (
    <div ref={ref} className={cx('page-scroll', className)} {...props}>
      {inner ? <div className={inner}>{children}</div> : children}
      {/* 스크롤 맨 위로 (§15.55) — fixed 레이아웃의 스크롤 소유자가 여기라서 버튼도 여기가 갖는다.
          바깥 div 의 직속 자식이라 버튼이 이 .page-scroll 을 스크롤 소유자로 찾는다(doc 레이아웃은 Shell 의 main 이 갖는다).
          짧은 화면은 scrollTop 이 threshold(400)를 못 넘어 저절로 숨는다 — 화면별 분기가 필요 없다. */}
      <ScrollTopButton />
    </div>
  );
});
